// apps/client/src/game/interactions/shake.ts (M1-T15) — A shakes the nearest tree in front that shows fruit for you (any tool or none).
import { tuning } from '@whiskerton/content';
import type { ObjectId, TreeState } from '@whiskerton/shared';
import type { Interaction } from '../interact';
import { objectsOf } from '../../net/handlers/nature';
import { useGame } from '../../state/store';
import { shakeTree, treeVisual } from '../../world/objects/tree';

/** Within reach and not behind you (the cosine of the angle off your facing). */
const FRONT_COS = 0.2;

export const interaction: Interaction = {
  id: 'shake',
  find(ctx) {
    const you = ctx.store.you;
    if (ctx.space !== 'out' || !you) return null;
    const now = ctx.game.now(), fx = Math.sin(ctx.f), fy = Math.cos(ctx.f);
    let best: { id: string; d: number; x: number; y: number } | null = null;
    for (const o of objectsOf(ctx.game)) {
      if (o.kind !== 'tree') continue;
      const x = o.x + 0.5, y = o.y + 0.5, dx = x - ctx.pos.x, dy = y - ctx.pos.y, d = Math.hypot(dx, dy);
      if (d > tuning.town.interactRange || (d > 0.3 && (dx * fx + dy * fy) / d < FRONT_COS)) continue;
      if (!treeVisual(o.state as TreeState, you.harvests[o.id] ?? null, now).fruitVisible) continue;
      if (!best || d < best.d) best = { id: o.id, d, x, y };
    }
    return best && { id: best.id, at: { x: best.x, y: best.y }, verb: 'hud.verbShake', priority: 55 };
  },
  run(ctx, c) {
    const tree = c.id as ObjectId, game = ctx.game;
    game.you()?.avatar.play('shake');
    void game.cmd.act('tree.shake', { tree }, { optimistic: () => { shakeTree(tree); return () => {}; } }).then((res) => {
      const you = useGame.getState().you;
      if (res.ok && you) game.scenes.out?.refreshPerResident(you);    // the fruit hides for you only
    });
  },
};
